export default {
    "en": {
        "All_Parents_Signin_With_Kakao": "Sign in with Kakao",
        "All_Parents_Signin_With_KakaoTalk": "Sign in with KakaoTalk",
        "All_Parents_Signin_With_Kakao_Account": "Sign in with Kakao Account",
        "All_Parents_Signin_With_Kakao_Alert": "Please note that “Sign in with Kakao” function is only available in Republic of Korea",
        "All_Parents_Signin_With_Google": "Sign in with Google",
        "All_Parents_Signin_With_Email": "Sign in with Email",
        "All_Parents_Signin_Or": "or",
        "All_Parents_Signin_Title1": "Welcome to Todo Math!",
        "All_Parents_Signin_Title1_Description1": "Enter your account information to sign in.",
        "All_Parents_Signin_Title1_InputBox1": "Email Address",
        "All_Parents_Signin_Title1_InputBox2": "Password",
        "All_Parents_Signin_Title1_Button1": "Sign in",
        "All_Parents_Signin_Title1_Button2": "Forgot password?",
        "All_Parents_Signin_Title1_Button3": "Sign up",
        "All_Parents_Signin_Title1_ErrorMessage1": "This account does not exist",
        "All_Parents_Signin_Title1_ErrorMessage2": "Incorrect password!",
        "All_Parents_Signin_Title1_ErrorMessage3": "Unauthorized Access.\nForward to Todo Math Website",
        "All_Parents_Signin_Title1_ErrorMessage4": "The period has expired.\nForward to Todo Math Website",
        "All_Parents_Signin_Title1_ErrorMessage5": "Please signin again.",
        "All_Parents_Signup_Title1": "Welcome to Todo Math!",
        "All_Parents_Signup_Title1_Description1": "Sign Up",
        "All_Parents_Signup_Title1_InputBox1": "Email Address",
        "All_Parents_Signup_Title1_InputBox2": "Password",
        "All_Parents_Signup_Title1_InputBox3": "Retype Password",
        "All_Parents_Signup_Title1_Button1": "Sign up",
        "All_Parents_Signup_Title1_ErrorMessage1": "Password is too short!",
        "All_Parents_Signup_Title1_ErrorMessage2": "Passwords do not match!",
        "All_Parents_Signup_Title1_ErrorMessage3": "The same password cannot be reused.",
        "All_Parents_Signup_Title1_ErrorMessage4": "Please enter at least 6digits combining letters and numbers.",
        "All_Parents_SignupAgreement_Title1": "Welcome to Todo Math!",
        "All_Parents_SignupAgreement_Title1_Description1": "Sign Up",
        "All_Parents_SignupAgreement_Title1_Description2": "I confirm that I am an adult and not a child under the age of 13. (Required)",
        "All_Parents_SignupAgreement_Title1_Description3": "I agree to register my email address and phone number to receive educational reports on my child's progress as well as marketing and promotional materials. (Optional)",
        "All_Parents_SignupAgreement_Title1_Description4": "If you consent to Todo Math's {Terms of Service} and {collection and use of personal information}, please press OK.",
        "All_Parents_SignupAgreement_Title1_Button1": "OK",
        "All_Parents_FindPassword_Title1": "Forgot password?",
        "All_Parents_FindPassword_Title1_Description1": "Enter your email address",
        "All_Parents_FindPassword_Title1_InputBox1": "Email Address",
        "All_Parents_FindPassword_Title1_Button1": "OK",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "This account does not exist",
        "All_Parents_FindPassword_Title1_ErrorMessage2": "This email is for kakao account",
        "All_Parents_FindPassword_Title1_ErrorMessage3": "This email is for google account",
        "All_Parents_FindPassword_Title1_ErrorMessage4": "This email is for apple account",
        "All_Parents_FindPassword_Title1_ErrorMessage5": "This email is for other service account",
        "All_Parents_FindPassword_Title1_ErrorMessage6": "",
        "All_Parents_FindPassword_Title1_SystemMessage1": "We sent an email to the address above. Please check your inbox!",
        "All_Parents_FindPassword_Title1_SystemMessage2": "Unauthorized Access. Forward to Todo Math Website",
        "All_Parents_FindPassword_Title1_Button2": "OK",
        "All_Parents_Myinfo_Title1": "My Purchase Summary",
        "All_Parents_Myinfo_Title1_label1": "Last purchase date",
        "All_Parents_Myinfo_Title1_label2": "Valid for",
        "All_Parents_Myinfo_Title1_label3": "Subscription plan",
        "All_Parents_Myinfo_Title2": "Learner",
        "All_Parents_Myinfo_Title2_label1": "Level",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "This account does not exist",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "Incorrect password!",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "Kakao account already exist",
        "All_Parents_Error_CA16": "Google account already exist",
        "All_Parents_Error_CA17": "Email account already exist",
        "All_Parents_Error_CA18": "Other service account already exist",
        "All_Parents_Error_CA27": "Please enter at least 6digits combining letters and numbers.",
        "All_Parents_Error_CA28": "Please enter at least 6digits combining letters and numbers.",
        "All_Parents_Error_CA29": "Please enter at least 6digits combining letters and numbers.",
        "All_Parents_Error_CA30": "The same password cannot be reused.",
        "All_Parents_ChangePassword_Title": "Please change your password.",
        "All_Parents_ChangePassword_Desc": "For security reasons, you will be asked to update your password every 12months.",
        "All_Parents_ChangePassword_Input1": "Current Password",
        "All_Parents_ChangePassword_Input2": "New Password",
        "All_Parents_ChangePassword_Input3": "Confirm New Password",
        "All_Parents_ChangePassword_Button": "Change",
        "All_Parents_ChangePassword_Button_Later": "Not now",
        "All_Parents_ChangePassword_Message1": "Your password has been changed.",
    },
    "ko": {
        "All_Parents_Signin_With_Kakao": "카카오로 시작하기",
        "All_Parents_Signin_With_KakaoTalk": "카카오톡으로 간편 로그인",
        "All_Parents_Signin_With_Kakao_Account": "다른 카카오계정으로 로그인",
        "All_Parents_Signin_With_Kakao_Alert": "",
        "All_Parents_Signin_With_Google": "구글로 시작하기",
        "All_Parents_Signin_With_Email": "이메일로 시작하기",
        "All_Parents_Signin_Or": "또는",
        "All_Parents_Signin_Title1": "토도수학에 오신 것을 환영합니다!",
        "All_Parents_Signin_Title1_Description1": "계정 정보를 입력하여 로그인합니다.",
        "All_Parents_Signin_Title1_InputBox1": "이메일 입력",
        "All_Parents_Signin_Title1_InputBox2": "비밀번호 입력",
        "All_Parents_Signin_Title1_Button1": "로그인",
        "All_Parents_Signin_Title1_Button2": "비밀번호 찾기",
        "All_Parents_Signin_Title1_Button3": "가입하기",
        "All_Parents_Signin_Title1_ErrorMessage1": "존재하지 않는 계정입니다.",
        "All_Parents_Signin_Title1_ErrorMessage2": "비밀번호가 틀렸습니다.",
        "All_Parents_Signin_Title1_ErrorMessage3": "할인 대상자로 확인 되지 않아\n토도수학 홈페이지로 연결 됩니다.",
        "All_Parents_Signin_Title1_ErrorMessage4": "아쉽게도 할인 기간이 만료 되어\n토도수학 홈페이지로 연결 됩니다.",
        "All_Parents_Signin_Title1_ErrorMessage5": "로그인 해주세요.",
        "All_Parents_Signup_Title1": "토도수학에 오신 것을 환영합니다!",
        "All_Parents_Signup_Title1_Description1": "가입하기",
        "All_Parents_Signup_Title1_InputBox1": "이메일",
        "All_Parents_Signup_Title1_InputBox2": "비밀번호",
        "All_Parents_Signup_Title1_InputBox3": "비밀번호 확인",
        "All_Parents_Signup_Title1_Button1": "가입",
        "All_Parents_Signup_Title1_ErrorMessage1": "비밀번호가 너무 짧습니다.",
        "All_Parents_Signup_Title1_ErrorMessage2": "비밀번호가 일치하지 않습니다.",
        "All_Parents_Signup_Title1_ErrorMessage3": "동일한 비밀번호를 다시 사용할 수 없습니다.",
        "All_Parents_Signup_Title1_ErrorMessage4": "영문과 숫자를 조합하여 6자 이상 입력하세요.",
        "All_Parents_SignupAgreement_Title1": "토도수학에 오신 것을 환영합니다!",
        "All_Parents_SignupAgreement_Title1_Description1": "가입하기",
        "All_Parents_SignupAgreement_Title1_Description2": "본인은 성인이며, 13세 이하의 아동이 아님을 확인합니다.(필수)",
        "All_Parents_SignupAgreement_Title1_Description3": "Email 및 휴대전화 번호를 등록하여 자녀의 학습 리포트와 할인 정보를 받아 보겠습니다. (선택)",
        "All_Parents_SignupAgreement_Title1_Description4": "토도수학의 {이용약관} 및 {개인정보 수집 및 이용}에 동의하시면 확인을 눌러주세요.",
        "All_Parents_SignupAgreement_Title1_Button1": "확인",
        "All_Parents_FindPassword_Title1": "비밀번호 찾기",
        "All_Parents_FindPassword_Title1_Description1": "이메일 주소 입력",
        "All_Parents_FindPassword_Title1_InputBox1": "이메일 입력",
        "All_Parents_FindPassword_Title1_Button1": "확인",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "존재하지 않는 계정입니다.",
        "All_Parents_FindPassword_Title1_ErrorMessage2": "카카오 계정으로 가입한 이메일 입니다.\n",
        "All_Parents_FindPassword_Title1_ErrorMessage3": "구글 계정으로 가입한 이메일 입니다.\n",
        "All_Parents_FindPassword_Title1_ErrorMessage4": "애플 계정으로 가입한 이메일 입니다.\n",
        "All_Parents_FindPassword_Title1_ErrorMessage5": "계정 타입을 확인해주세요.\n이메일 외의 계정의 경우 ",
        "All_Parents_FindPassword_Title1_ErrorMessage6": "비밀번호 변경은 해당 계정 서비스에서 가능합니다.",
        "All_Parents_FindPassword_Title1_SystemMessage1": "비밀번호 변경을 위한 이메일을 발송하였습니다. 메일함을 확인해주세요.",
        "All_Parents_FindPassword_Title1_SystemMessage2": "접근권한이 없습니다. 토도수학 홈페이지로 돌아갑니다.",
        "All_Parents_FindPassword_Title1_Button2": "확인",
        "All_Parents_Myinfo_Title1": "구매 내역",
        "All_Parents_Myinfo_Title1_label1": "마지막 구매 날짜",
        "All_Parents_Myinfo_Title1_label2": "유효기간",
        "All_Parents_Myinfo_Title1_label3": "구독상품",
        "All_Parents_Myinfo_Title2": "사용자",
        "All_Parents_Myinfo_Title2_label1": "레벨",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "존재하지 않는 계정입니다.",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "비밀번호가 일치하지 않습니다.",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "Kakao account already exist",
        "All_Parents_Error_CA16": "Google account already exist",
        "All_Parents_Error_CA17": "Email account already exist",
        "All_Parents_Error_CA18": "Other service account already exist",
        "All_Parents_Error_CA27": "영문과 숫자를 조합하여 6자 이상 입력하세요.",
        "All_Parents_Error_CA28": "영문과 숫자를 조합하여 6자 이상 입력하세요.",
        "All_Parents_Error_CA29": "영문과 숫자를 조합하여 6자 이상 입력하세요.",
        "All_Parents_Error_CA30": "동일한 비밀번호를 다시 사용할 수 없습니다.",
        "All_Parents_ChangePassword_Title": "비밀번호를 변경해 주세요.",
        "All_Parents_ChangePassword_Desc": "회원님의 정보 보호를 위해 12개월 주기로 비밀번호 변경을 안내합니다.",
        "All_Parents_ChangePassword_Input1": "현재 비밀번호",
        "All_Parents_ChangePassword_Input2": "새로운 비밀번호",
        "All_Parents_ChangePassword_Input3": "새로운 비밀번호 확인",
        "All_Parents_ChangePassword_Button": "변경",
        "All_Parents_ChangePassword_Button_Later": "나중에 하기",
        "All_Parents_ChangePassword_Message1": "비밀번호가 변경되었습니다.",
    },
    "cn": {
        "All_Parents_Signin_With_Kakao": "Sign in with Kakao",
        "All_Parents_Signin_With_KakaoTalk": "使用Kaokao登陆",
        "All_Parents_Signin_With_Kakao_Account": "使用另外的Kaokao账号登陆。",
        "All_Parents_Signin_With_Kakao_Alert": "请注意，“使用Kakao登录“功能仅在韩国提供",
        "All_Parents_Signin_With_Google": "Sign in with Google",
        "All_Parents_Signin_With_Email": "Sign in with Email",
        "All_Parents_Signin_Or": "or",
        "All_Parents_Signin_Title1": "欢迎来到都都数学！",
        "All_Parents_Signin_Title1_Description1": "输入您的帐户信息以登录。",
        "All_Parents_Signin_Title1_InputBox1": "输入电子邮箱",
        "All_Parents_Signin_Title1_InputBox2": "输入密码",
        "All_Parents_Signin_Title1_Button1": "登陆",
        "All_Parents_Signin_Title1_Button2": "您忘记密码了吗？",
        "All_Parents_Signin_Title1_Button3": "注册",
        "All_Parents_Signin_Title1_ErrorMessage1": "用户不存在",
        "All_Parents_Signin_Title1_ErrorMessage2": "密码错误！",
        "All_Parents_Signin_Title1_ErrorMessage3": "Unauthorized Access.\nForward to Todo Math Website",
        "All_Parents_Signin_Title1_ErrorMessage4": "The period has expired.\nForward to Todo Math Website",
        "All_Parents_Signin_Title1_ErrorMessage5": "Please signin again.",
        "All_Parents_Signup_Title1": "欢迎来到都都数学！",
        "All_Parents_Signup_Title1_Description1": "注册",
        "All_Parents_Signup_Title1_InputBox1": "电子邮箱",
        "All_Parents_Signup_Title1_InputBox2": "密码",
        "All_Parents_Signup_Title1_InputBox3": "重新输入密码",
        "All_Parents_Signup_Title1_Button1": "注册",
        "All_Parents_Signup_Title1_ErrorMessage1": "密码太短！",
        "All_Parents_Signup_Title1_ErrorMessage2": "密码不匹配！",
        "All_Parents_Signup_Title1_ErrorMessage3": "不可以使用与上次相同的密码。",
        "All_Parents_Signup_Title1_ErrorMessage4": "密码需要包含英文字母和数字，且不少于6 位字符。",
        "All_Parents_SignupAgreement_Title1": "欢迎来到都都数学！",
        "All_Parents_SignupAgreement_Title1_Description1": "注册",
        "All_Parents_SignupAgreement_Title1_Description2": "我确定我是一名成年人而不是一个不到13岁的孩子。(必需)",
        "All_Parents_SignupAgreement_Title1_Description3": "我同意注册我的电子邮件地址和电话号码，以接收有关我孩子的进度以及市场营销和促销材料的教育报告。 （可选的）",
        "All_Parents_SignupAgreement_Title1_Description4": "如果您同意都都数学的 {Terms of Service} 和 {collection and use of personal information}, 请按确定。",
        "All_Parents_SignupAgreement_Title1_Button1": "确定",
        "All_Parents_FindPassword_Title1": "您忘记密码了吗？",
        "All_Parents_FindPassword_Title1_Description1": "输入您的电子邮件",
        "All_Parents_FindPassword_Title1_InputBox1": "输入电子邮箱",
        "All_Parents_FindPassword_Title1_Button1": "确定",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "用户不存在",
        "All_Parents_FindPassword_Title1_ErrorMessage2": "This email is for kakao account",
        "All_Parents_FindPassword_Title1_ErrorMessage3": "This email is for google account",
        "All_Parents_FindPassword_Title1_ErrorMessage4": "This email is for apple account",
        "All_Parents_FindPassword_Title1_ErrorMessage5": "This email is for other service account",
        "All_Parents_FindPassword_Title1_ErrorMessage6": "",
        "All_Parents_FindPassword_Title1_SystemMessage1": "",
        "All_Parents_FindPassword_Title1_SystemMessage2": "",
        "All_Parents_FindPassword_Title1_Button2": "确定",
        "All_Parents_Myinfo_Title1": "我的订阅情况",
        "All_Parents_Myinfo_Title1_label1": "最近的购买",
        "All_Parents_Myinfo_Title1_label2": "有效期",
        "All_Parents_Myinfo_Title1_label3": "",
        "All_Parents_Myinfo_Title2": "学习者",
        "All_Parents_Myinfo_Title2_label1": "水平",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "用户不存在",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "密码错误！",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "该邮箱已用Kakao登录方式被注册。",
        "All_Parents_Error_CA16": "该邮箱已用Google登录方式被注册。",
        "All_Parents_Error_CA17": "该邮箱已用邮箱登录方式被注册。",
        "All_Parents_Error_CA18": "该邮箱已以其他登录方式被注册。",
        "All_Parents_Error_CA27": "密码需要包含英文字母和数字，且不少于6 位字符。",
        "All_Parents_Error_CA28": "密码需要包含英文字母和数字，且不少于6 位字符。",
        "All_Parents_Error_CA29": "密码需要包含英文字母和数字，且不少于6 位字符。",
        "All_Parents_Error_CA30": "不可以使用与上次相同的密码。",
        "All_Parents_ChangePassword_Title": "请更新您的密码。",
        "All_Parents_ChangePassword_Desc": "由于安全需要，我们会每12个月请求您更新一次您的密码。",
        "All_Parents_ChangePassword_Input1": "旧密码",
        "All_Parents_ChangePassword_Input2": "新密码",
        "All_Parents_ChangePassword_Input3": "确认新密码",
        "All_Parents_ChangePassword_Button": "更换",
        "All_Parents_ChangePassword_Button_Later": "稍后完成",
        "All_Parents_ChangePassword_Message1": "密码已更改。",
        "Cn_Main_Body_Download_Android_Popup_Title": "都都数学",
        "Cn_Main_Body_Download_Android_Popup_Description1": "本Android版本仅供中国大陆地区使用，\n在其他国家或地区可能无法正常使用。",
        "Cn_Main_Body_Download_Android_Popup_Description2": "*如果您已经安装了“都都数学“，您可以启动它来获取适用的更新。",
        "Cn_Main_Body_Download_Android_Popup_Description3": "*如果您发现更新之后存在两个“都都数学“，请手动删除之前的版本。",
        "Cn_Main_Body_Download_Buttn_Name": "下载"
    },
    "ja": {
        "All_Parents_Signin_With_Kakao": "Sign in with Kakao",
        "All_Parents_Signin_With_KakaoTalk": "カカオトークで簡単ログイン",
        "All_Parents_Signin_With_Kakao_Account": "他のカカオアカウントでログイン",
        "All_Parents_Signin_With_Kakao_Alert": "「カカオで開始する」と会員登録時に大韓民国でのみ正常にご利用が可能です。",
        "All_Parents_Signin_With_Google": "Sign in with Google",
        "All_Parents_Signin_With_Email": "Sign in with Email",
        "All_Parents_Signin_Or": "or",
        "All_Parents_Signin_Title1": "トドさんすうへようこそ！",
        "All_Parents_Signin_Title1_Description1": "アカウント情報を入力してログインします。",
        "All_Parents_Signin_Title1_InputBox1": "メールアドレス入力",
        "All_Parents_Signin_Title1_InputBox2": "パスワード入力",
        "All_Parents_Signin_Title1_Button1": "ログイン",
        "All_Parents_Signin_Title1_Button2": "パスワードを忘れた場合",
        "All_Parents_Signin_Title1_Button3": "登録",
        "All_Parents_Signin_Title1_ErrorMessage1": "存在しないアカウントです。",
        "All_Parents_Signin_Title1_ErrorMessage2": "パスワードが間違っています！",
        "All_Parents_Signin_Title1_ErrorMessage3": "Unauthorized Access.\nForward to Todo Math Website",
        "All_Parents_Signin_Title1_ErrorMessage4": "The period has expired.\nForward to Todo Math Website",
        "All_Parents_Signin_Title1_ErrorMessage5": "Please signin again.",
        "All_Parents_Signup_Title1": "トドさんすうへようこそ！",
        "All_Parents_Signup_Title1_Description1": "会員登録",
        "All_Parents_Signup_Title1_InputBox1": "メールアドレス",
        "All_Parents_Signup_Title1_InputBox2": "パスワード",
        "All_Parents_Signup_Title1_InputBox3": "パスワードを再入力してください",
        "All_Parents_Signup_Title1_Button1": "登録",
        "All_Parents_Signup_Title1_ErrorMessage1": "パスワードが短すぎます！",
        "All_Parents_Signup_Title1_ErrorMessage2": "パスワードが一致しません！",
        "All_Parents_Signup_Title1_ErrorMessage3": "同じパスワードを再度使用することはできません。",
        "All_Parents_Signup_Title1_ErrorMessage4": "半角英数字を組み合わせて6文字以上で入力してください。",
        "All_Parents_SignupAgreement_Title1": "トドさんすうへようこそ！",
        "All_Parents_SignupAgreement_Title1_Description1": "会員登録",
        "All_Parents_SignupAgreement_Title1_Description2": "私は成人で、13歳以下の子どもではないことを確認しました。（必須）",
        "All_Parents_SignupAgreement_Title1_Description3": "メールアドレス、及び携帯電話番号を登録し、子どもの学習レポートとお得なセール情報を受け取ります。（選択）",
        "All_Parents_SignupAgreement_Title1_Description4": "トドさんすうの {利用規約} 及び {個人情報の収集と利用} に同意する場合は、「確認」をタップしてください。",
        "All_Parents_SignupAgreement_Title1_Button1": "確認",
        "All_Parents_FindPassword_Title1": "パスワードを忘れた場合",
        "All_Parents_FindPassword_Title1_Description1": "メールアドレス入力",
        "All_Parents_FindPassword_Title1_InputBox1": "メールアドレス入力",
        "All_Parents_FindPassword_Title1_Button1": "確認",
        "All_Parents_FindPassword_Title1_ErrorMessage1": "存在しないアカウントです。",
        "All_Parents_FindPassword_Title1_ErrorMessage2": "This email is for kakao account",
        "All_Parents_FindPassword_Title1_ErrorMessage3": "This email is for google account",
        "All_Parents_FindPassword_Title1_ErrorMessage4": "This email is for apple account",
        "All_Parents_FindPassword_Title1_ErrorMessage5": "This email is for other service account",
        "All_Parents_FindPassword_Title1_ErrorMessage6": "",
        "All_Parents_FindPassword_Title1_SystemMessage1": "上記のメールアドレスにメールを送信しました。受信トレイを確認してください。",
        "All_Parents_FindPassword_Title1_SystemMessage2": "",
        "All_Parents_FindPassword_Title1_Button2": "確認",
        "All_Parents_Myinfo_Title1": "購入内訳",
        "All_Parents_Myinfo_Title1_label1": "最終購入日",
        "All_Parents_Myinfo_Title1_label2": "有効期間",
        "All_Parents_Myinfo_Title1_label3": "",
        "All_Parents_Myinfo_Title2": "ユーザー",
        "All_Parents_Myinfo_Title2_label1": "レベル",
        "All_Parents_Error_CA00": "Internal Server Error",
        "All_Parents_Error_CA01": "存在しないアカウントです。",
        "All_Parents_Error_CA03": "Migration Failed",
        "All_Parents_Error_CA04": "Email address is Duplicated",
        "All_Parents_Error_CA06": "パスワードが間違っています！",
        "All_Parents_Error_CA07": "Password not found",
        "All_Parents_Error_CA08": "Password already exist",
        "All_Parents_Error_CA09": "migration failed (school)",
        "All_Parents_Error_CA10": "email address is invalid",
        "All_Parents_Error_CA11": "black list email domain",
        "All_Parents_Error_CA12": "Token not found",
        "All_Parents_Error_CA13": "Token expired",
        "All_Parents_Error_CA14": "SupportKey duplicated",
        "All_Parents_Error_CA15": "Kakao account already exist",
        "All_Parents_Error_CA16": "Google account already exist",
        "All_Parents_Error_CA17": "Email account already exist",
        "All_Parents_Error_CA18": "Other service account already exist",
        "All_Parents_Error_CA27": "半角英数字を組み合わせて6文字以上で入力してください。",
        "All_Parents_Error_CA28": "半角英数字を組み合わせて6文字以上で入力してください。",
        "All_Parents_Error_CA29": "半角英数字を組み合わせて6文字以上で入力してください。",
        "All_Parents_Error_CA30": "同じパスワードを再度使用することはできません。",
        "All_Parents_ChangePassword_Title": "パスワードを変更してください。",
        "All_Parents_ChangePassword_Desc": "お客様の情報保護のため、12か月ごとにパスワード変更をご案内いたします。",
        "All_Parents_ChangePassword_Input1": "現在のパスワード",
        "All_Parents_ChangePassword_Input2": "新しいパスワード",
        "All_Parents_ChangePassword_Input3": "新しいパスワードの確認",
        "All_Parents_ChangePassword_Button": "変更",
        "All_Parents_ChangePassword_Button_Later": "後でする",
        "All_Parents_ChangePassword_Message1": "パスワードが変更されました。",
    }
}



// WEBPACK FOOTER //
// ./src/text/parent/laptop.js